export default function deletedAtFactory(deleteAt) {
  async function setDeletedAtForSelectedFiles({ state, graphql }) {
    const files = state.get('media.filesToDelete')
    if (files) {
      const ids = files.map(mediaId => {
        return `"${mediaId}"`
      })
      await graphql.mutate(
        `{deleteAtMedias(ids: [${ids.join()}], deletedAt: ${deleteAt})}`
      )
    }
  }

  return setDeletedAtForSelectedFiles
}



// WEBPACK FOOTER //
// ./src/modules/Media/factories/setDeletedAtForSelectedFiles.js